var enquiryNowCustomerId = "";
function logCustomerDetail(productHandle) {
  console.log("logCustomerDetail")
//   window.fcWidget.open();window.fcWidget.show();
 $zoho.salesiq.floatwindow.visible("1");
  $zoho.salesiq.floatwindow.visible("show");
  window.fcWidget.open();window.fcWidget.show();
//   $zoho.salesiq.floatbutton.visible(" show | hide | delayinsecs ");

  enquiryNowCustomerId = $('.customer_id').val();
  
  if (enquiryNowCustomerId !== undefined && enquiryNowCustomerId !== null &&
      enquiryNowCustomerId.length > 0) {
    enquiryNowCustomerId = $('.customer_id').val();
  } else {
    enquiryNowCustomerId = "";
  }
  
  var productHandleUrl = "https://apps.ninjaas.com:8090/api/v4/products/variants";
  let requestBodyObj = {};
  requestBodyObj["handles"] = [productHandle];
  requestBodyObj = JSON.stringify(requestBodyObj);
  
  $.ajax({
        type: 'POST',
        timeout: ajaxCallTimeout,
        dataType: 'json',
        contentType: 'application/json',
        error: function (data) {
            console.log(data);
        },
        url: productHandleUrl,
    	data:requestBodyObj,
        beforeSend: function (xhr) {
            
        },
        complete: function () {
        },
        statusCode: {
            200: function (data) {
              logProductDetail(data)
            },
            302: function () {
                swal({
                    title: 'Sorry',
                    text: "Session expired. Please login again.",
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            403: function () {
                swal({
                    title: 'Error!',
                    text: 'You do not have enough privilege to perform this request.' +
                    'Please contact seller support.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            400: function () {
                swal({
                    title: 'Invalid Input!',
                    text: 'Invalid request please check input.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            },
            422: function () {
                swal({
                    title: '',
                    text: "Email id not exists",
                    type: 'warning',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
                $('.swal2-confirm').click(function () {
                    location.reload(true);
                });
            },
            500: function () {
                swal({
                    title: 'Internal Server Error !',
                    text: 'Internal server error. We could not perform the operation this time. ' +
                    'Please try again later.',
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false
                });
            }
        }
    });
}

function logProductDetail(data){
  var productDetailObj = {};
  if (data !== undefined && Object.keys(data).length > 0) {
    let productsArray = data.products;
    if (productsArray.length > 0) {
      let productObj = productsArray[0];
      let variantsArray = productObj.variants;
      if (variantsArray !== undefined && variantsArray.length > 0) {
        let variantObj = variantsArray[0];
        if (variantObj !== undefined && Object.keys(variantObj).length > 0) {
          productDetailObj["productId"] = variantObj.product_id;
          productDetailObj["variantId"] = variantObj.id;
          productDetailObj["SKU"] = variantObj.sku;
          productDetailObj["price"] = variantObj.is_variant_in_sale ? variantObj.variant_sale_price : variantObj.price
        }
      }
    }
  }
  productDetailObj["customerId"] = customerId;
  let stringifyProductDetail = JSON.stringify(productDetailObj);
  Sentry.captureMessage("precious jewellery enquiry detail: "+stringifyProductDetail);
}